import './App.css';
import RootRoutes  from './routes'
import './assets/css/style.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './store';


function App() {
  return (
    <ReduxProvider store={store}>
      <RootRoutes/>
    </ReduxProvider>
  );
}

export default App;
